function resetPrecedence() {
  // Reset the visible precedence value after each remove
  var row_count = 1;
  $(".nested-fields:visible [id*='_precedence']").each(function () {
    $(this).val(row_count++);
  });
}

$(document).ready(function () {
  (function () {
    $(".simple_form").on("cocoon:after-remove", function (event, elem) {
      resetPrecedence();
    });
  }.call(this));

  (function () {
    // Auto increment on the precedence
    $(".simple_form").on("cocoon:after-insert", function (event, elem) {
      resetPrecedence();
    });
  }.call(this));

  $(document).on("change", "#check_in_event_frequency_type", function () {
    $("#freq_type_th").html(
      "<p><strong>" + this.options[this.selectedIndex].text + "</strong></p>"
    );
  });
});
